// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove gray background outside filter options in MultiSelect filter panel */
.p-multiselect-panel {
	background: #fff !important;
}

/* Optional: Remove background from overlay mask if present */
.cdk-overlay-backdrop, .p-overlaypanel-mask {
	background: transparent !important;
}
/* Restriction Component Styles */

:host ::ng-deep .p-panel-header{
	border-bottom: 3px solid #3498db !important;
    padding-bottom: 8px !important;
 }`, "",{"version":3,"sources":["webpack://./src/app/admin/restriction/restriction.component.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;CACC,2BAA2B;AAC5B;;AAEA,6DAA6D;AAC7D;CACC,kCAAkC;AACnC;AACA,iCAAiC;;AAEjC;CACC,2CAA2C;IACxC,8BAA8B;CACjC","sourcesContent":["/* Remove gray background outside filter options in MultiSelect filter panel */\r\n.p-multiselect-panel {\r\n\tbackground: #fff !important;\r\n}\r\n\r\n/* Optional: Remove background from overlay mask if present */\r\n.cdk-overlay-backdrop, .p-overlaypanel-mask {\r\n\tbackground: transparent !important;\r\n}\r\n/* Restriction Component Styles */\r\n\r\n:host ::ng-deep .p-panel-header{\r\n\tborder-bottom: 3px solid #3498db !important;\r\n    padding-bottom: 8px !important;\r\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
